import React from 'react';

const viLoopList = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path d="M20.5 7H10.5C7.18629 7 4.5 9.68629 4.5 13C4.5 16.3137 7.18629 19 10.5 19H20.5M20.5 7L16.5 3M20.5 7L16.5 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default viLoopList;
